import { render, staticRenderFns } from "./SystemMenu.vue?vue&type=template&id=2c120aee&scoped=true"
import script from "./SystemMenu.vue?vue&type=script&lang=js"
export * from "./SystemMenu.vue?vue&type=script&lang=js"
import style0 from "./SystemMenu.vue?vue&type=style&index=0&id=2c120aee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c120aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c120aee')) {
      api.createRecord('2c120aee', component.options)
    } else {
      api.reload('2c120aee', component.options)
    }
    module.hot.accept("./SystemMenu.vue?vue&type=template&id=2c120aee&scoped=true", function () {
      api.rerender('2c120aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemMenu/SystemMenu.vue"
export default component.exports